import { LoginService } from '../../../core/services/login.service';
import { Filter } from '../../../core/models/filter';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { combineLatest } from 'rxjs';
import { pluck } from 'rxjs/operators';
const getSupportRequestSubscription = gql`query get_support_requests( $andList: [support_requests_bool_exp!], $limit: Int, $offset: Int){
  support_requests(where: {
    _and: $andList,
  },
  order_by:{created_at:desc},
  limit: $limit, offset:$offset){
    id
    created_at
    updated_at
    supplies_order_id
    supplies_order{
      id
      order_number
    }
    second_hand_supplies_order_id
    second_hand_supplies_order{
      id
      order_number
    }
    reason
    message
    attachments
    status
    reply
    reply_attachments
    support_request_number
    type
  }
}`;

const getSupportRequestAggregateSubscription = gql`query get_support_request_aggregate($andList: [support_requests_bool_exp!]){
  support_requests_aggregate(where: {
    _and: $andList,
  }){
    aggregate{
      count
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupportRequestService {

  constructor(
    private apollo: Apollo,
    private loginService: LoginService) { }

  getSupportRequests(filter: Filter){
    const loginData = this.loginService.getLoginData();
    const andList: any = [];
    andList.push({
      "_or": [
        {
        "dental_supplier_id": {"_eq": loginData.id }
        },
        {
          "dental_practice_id": {"_eq": loginData.id }
        },
        {
          "dental_professional_id": {"_eq": loginData.id }
        }
      ]});
    if(filter.search){
      andList.push({
        "support_request_number": {"_eq": filter.search}
      })
    }
    if(filter.status){
      andList.push({
        "status": {"_eq": filter.status}
      })
    }
    return combineLatest([
      this.apollo.use('external').query({
        query: getSupportRequestSubscription,
        variables: {
          andList,
          limit: filter.limit,
          offset: filter.offset
        }
      }).pipe(pluck(
        'data',
        'support_requests',
        )),
      this.apollo.use('external').query({
        query: getSupportRequestAggregateSubscription,
        variables: {
          andList
        }
      }).pipe(pluck(
      'data',
      'support_requests_aggregate',
      'aggregate',
      'count'
      ))
    ]);
  }
}
